import { createFileRoute } from "@tanstack/react-router";

import VerificationsPage from "@/features/dashboard/pages/verifications";

export const Route = createFileRoute("/(app)/dashboard/verifications")({
  component: () => <VerificationsPage />,
});
